// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  // Only one zoom overlay at a time — close any left open on another image
  document.querySelectorAll('.image-magnify-full-size').forEach((el) => el.remove());
  const overlay = createOverlay(image);
  const close = () => {
    overlay.remove();
    document.removeEventListener('keyup', onKeyUp);
  };
  const onKeyUp = (event) => {
    if (event.key === 'Escape') close();
  };
  overlay.onclick = close;
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  // Zoom stays active when the mouse leaves the image; click or Esc closes it
  document.addEventListener('keyup', onKeyUp);
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    // Warm the cache on first hover so the full-size copy is already
    // downloaded by the time the shopper clicks (no loading spinner)
    image.onmouseenter = () => {
      if (!image.dataset.zoomPreloaded) {
        image.dataset.zoomPreloaded = 'true';
        new Image().src = image.src;
      }
    };
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
